import { FC, JSX } from 'react';
import { cn } from '@src/lib/utils';

interface StepProps {
  stepNumber: number;
  title: string | JSX.Element;
  status: 'completed' | 'in progress' | 'pending';
}

export const Step: FC<StepProps> = ({ stepNumber, title, status }) => {
  return (
    <div className=" ml-5 relative flex flex-col justify-center gap-4 flex-1 py-6">
      <div className="flex items-center">
        <div
          className={cn(
            'flex h-5 w-5 items-center justify-center rounded-full border-2 transition-colors mr-6',
            status === 'completed' && 'border-[#007AFE] bg-[#007AFE]',
            status === 'in progress' &&
              'border-[#007AFE] border-1 bg-transparent',
            status === 'pending' && 'border-0 bg-[#4D5C7233]'
          )}
        >
          {status === 'completed' ? (
            <svg
              className="h-5 w-5 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M5 13l4 4L19 7"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
              />
            </svg>
          ) : (
            <div
              className={`${status === 'in progress' ? 'bg-[#007AFE]' : 'bg-transparent'} w-2.5 h-2.5 rounded-full`}
            />
          )}
        </div>

        <div
          className={cn(
            'h-[3px] flex-1 rounded-full',
            status === 'completed' ? 'bg-[#007AFE]' : 'bg-[#4D5C72]'
          )}
        />
      </div>

      <div className="flex-1">
        <div className="text-xs text-[#ABB7C2] font-medium font-[Roboto]">
          STEP {stepNumber}
        </div>
        <div className="mt-1 text-sm font-medium text-white font-[Roboto]">
          {title}
        </div>
        <div
          className={`mt-3 text-sm text-[${status === 'completed' ? '#14CA74' : status === 'in progress' ? '#007AFE' : '#4D5C72'}] capitalize font-[Roboto] ${status === 'pending' && 'text-[#ABB7C2]'}`}
        >
          {status}
        </div>
      </div>
    </div>
  );
};
